import * as S from './index.style'
import { Button, Modal } from '@material-ui/core'
import React from 'react'
import Loading from 'components/Loading'
import { processandoDados } from 'helpers/Constantes/Mensagens'
import { DialogHeader } from 'components/DialogHeader'
import { EstadoModalEnum } from 'models/Viabilidade/Enum/EstadoModalEnum'

export type ConfirmModalProps = {
  funcaoConfirmar: () => void
  funcaoCancelar: () => void
  funcaoOk: () => void
  estadoModal: EstadoModalEnum
  titulo: string
  botaoConfirmacao: string
  botaoCancelar: string
  textoSucesso: string
  textoErro: string
  children: React.ReactNode
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  funcaoConfirmar,
  funcaoCancelar,
  funcaoOk,
  estadoModal,
  titulo,
  botaoConfirmacao,
  botaoCancelar,
  textoSucesso,
  textoErro,
  children
}) => {
  return (
    <Modal open={estadoModal != EstadoModalEnum.Fechado}>
      <S.BoxCustomizado data-cy="confirmModal">
        {estadoModal == EstadoModalEnum.Confirmacao ? (
          <>
            {titulo !== '' && (
              <>
                <DialogHeader titulo={''} closedDialog={funcaoCancelar}></DialogHeader>
                <S.Titulo>{titulo}</S.Titulo>
              </>
            )}
            <S.Conteudo data-cy="estadoConfirmacao">
              {children}
              <S.Linha />
              <S.Botoes>
                <S.BotaoSim data-cy="btnSim" variant="text" color="primary" onClick={funcaoConfirmar}>
                  {botaoConfirmacao}
                </S.BotaoSim>
                <Button data-cy="btnNao" variant="contained" color="secondary" onClick={funcaoCancelar}>
                  {botaoCancelar}
                </Button>
              </S.Botoes>
            </S.Conteudo>
          </>
        ) : estadoModal == EstadoModalEnum.Sucesso ? (
          <S.Conteudo data-cy="estadoSucesso">
            <S.IconCheck />
            <S.Linha />
            <S.Texto>{textoSucesso}</S.Texto>
            <S.Linha />
            <S.Botoes>
              <Button data-cy="btnOk" variant="contained" color="secondary" onClick={funcaoOk}>
                Ok
              </Button>
            </S.Botoes>
          </S.Conteudo>
        ) : estadoModal == EstadoModalEnum.Erro ? (
          <S.Conteudo data-cy="estadoErro">
            <S.IconErro />
            <S.Linha />
            <S.Texto>
              {textoErro}
              <br />
              Tente novamente mais tarde.
            </S.Texto>
            <S.Linha />
            <S.Botoes>
              <Button data-cy="btnOk" variant="contained" color="secondary" onClick={funcaoCancelar}>
                Ok
              </Button>
            </S.Botoes>
          </S.Conteudo>
        ) : (
          <S.Conteudo data-cy="estadoLoading">
            <Loading />
            <S.TextoLoading>{processandoDados}</S.TextoLoading>
          </S.Conteudo>
        )}
      </S.BoxCustomizado>
    </Modal>
  )
}

export default ConfirmModal
